export enum IdentityType {
	Internal = 'INTERNAL',
	External = 'EXTERNAL',
}

export interface IAggregationBucket {
	key: string;
	docCount: number;
}

export type IAggregations = Record<string, { name: string; buckets?: IAggregationBucket[]; value?: number }>;

export type ElasticSearchHit = Record<string, any>;

export interface IElasticSearchResp {
	aggregations?: IAggregations;
	hits: ElasticSearchHit[];
	totalHits: number;
}

export interface IGetObjects {
	from?: number;
	size?: number;
	must?: Record<string, string[]>;
	mustNot?: Record<string, string[]>;
	should?: Record<string, string[]>;
	filters?: Record<string, string[]>;
	postFilters?: Record<string, string[]>;
	fields?: string[];
	sort?: Record<string, string>;
	aggs?: string[];
	find?: {
		text: string;
		fields: string[];
	};
}

export interface IGetAssetsArgs {
	ids?: string[];
	identityType?: IdentityType;
	fields?: string[];
	sort?: Record<string, string>;
	offset?: number;
	size?: number;
	find?: string;
	filters?: Record<string, string[]>;
	postFilters?: Record<string, string[]>;
	mustNot?: Record<string, string[]>;
	aggs?: string[];
}

export interface IGetRelationshipsArgs {
	sourceIdentities?: string[];
	targetIdentities?: string[];
	associationIds?: string[];
	associationKinds?: string[];
	offset?: number;
	size?: number;
	filters?: Record<string, string[]>;
	postFilters?: Record<string, string[]>;
	mustNot?: Record<string, string[]>;
	aggs?: string[];
}
